import { createSelector } from '@ngrx/store';
import { getMfePhoneState } from '@store/reducers';

export const selectMfePhone = createSelector(getMfePhoneState, (state) => state);

export const selectMfePhoneNumber = createSelector(getMfePhoneState, (state) => state.phoneNumber);

export const selectMfePhoneMobileFlag = createSelector(getMfePhoneState, (state) => state.isMobile);

export const selectMfePhoneValidationStatus = createSelector(
  getMfePhoneState,
  (state) => state.validationStatus,
);
